import schemaResolver from '.';

/**
 * Returns the name value in order of Location > Distance
 * @param {*} labels
 */
const getName = (labels) => {
  const locationIndex = labels.findIndex((label) => label.type === 'Location');
  if (locationIndex !== -1) return labels[locationIndex].value;

  const distanceIndex = labels.findIndex((label) => label.type === 'Distance');
  if (distanceIndex !== -1) return labels[distanceIndex].value;

  return '';
};

const crumbs = (category) => {
  const listLength = category.parents.length;
  const currentCrumb = {
    '@type': 'ListItem',
    position: listLength + 1,
    name: getName(category.labels),
    item: `${WEB_ROOT}/${category.path}`,
  };

  const breadcrumbs = category.parents
    .filter((t) => !!t.path)
    .reverse()
    .map((breadcrumb, index) => {
      const { path, labels } = breadcrumb;
      const absolutePermalink = `${WEB_ROOT}/${path}`;

      return {
        '@type': 'ListItem',
        position: index + 1,
        name: getName(labels),
        item: absolutePermalink,
      };
    })
    .concat(currentCrumb);

  return breadcrumbs;
};

export const categoryBreadcrumbResolver = (category) =>
  category && {
    itemListElement: crumbs(category),
  };

const resolver = (obj) =>
  schemaResolver(categoryBreadcrumbResolver(obj), 'BreadcrumbList');

export default resolver;
